// frontend/app/locales/it.ts
export const it = {
  sidebar: {
    main: "Principale",
    planning: "Pianificazione",
    closings: "Chiusure",
    system: "Sistema",
    dashboard: "Dashboard",
    transactions: "Transazioni",
    investments: "Investimenti",
    calendar: "Calendario",
    recurring: "Abbonamenti",
    envelopes: "Fondi & Buste",
    debts: "Debiti & Crediti",
    goals: "Obiettivi",
    documents: "Document Inbox",
    balance: "Bilancio",
    data: "Anagrafiche",
    settings: "Impostazioni",
    logout: "Esci",
    login: "Accedi",
    language: "Lingua",
    more: "Altro",
    home: "Home",
    expenses: "Spese",
    envelopes_short: "Buste",
    wishlist: "Desideri",
    admin_section: "Amministrazione",
    admin_users: "Gestione Utenti",
    admin_market: "Monitor Titoli",
    support: "Assistenza",
    admin_tickets: "Gestione Ticket",
    admin_analytics: "Statistiche Uso",
    admin_settings: "Impostazioni Sistema",
  },
  settings: {
    title: "Impostazioni",
    subtitle: "Gestisci le tue preferenze, il profilo e le chiavi di sicurezza.",
    profile: "Profilo Personale",
    preferences: "Preferenze di Sistema",
    security: "Sicurezza",
    database_status: "Stato Database",
    export_import: "Esporta & Importa",
    email_briefings: "Briefing Giornaliero e Report",
    save: "Salva Impostazioni",
    change_password: "Cambia Password",
    current_password: "Password Attuale",
    new_password: "Nuova Password",
    confirm_password: "Conferma Password",
    bio_authentication: "Autenticazione Biometrica (Passkeys)",
    register_passkey: "Registra Passkey",
    db_status_msg: "Il database PostgreSQL è attivo e sincronizzato correttamente.",
    export_btn: "Esporta Dati JSON",
    import_btn: "Importa Dati JSON",
    receive_briefings: "Ricevi briefing mattutino",
    receive_weekly: "Ricevi report settimanale",
    receive_monthly: "Ricevi report mensile",
    base_currency: "Valuta Base",
    timezone: "Timezone",
    theme_label: "Tema di Visualizzazione",
    theme_dark: "Scuro (Dark Mode)",
    theme_light: "Chiaro (Light Mode)",
    personal_info: {
      username: "Username",
      email: "Email",
      first_name: "Nome",
      last_name: "Cognome",
      date_of_birth: "Data di Nascita",
      phone_number: "Numero di Telefono",
      address: "Indirizzo",
      city: "Città",
      state: "Regione/Provincia",
      postal_code: "CAP",
      country: "Nazione",
      gender: "Genere",
      select_gender: "Seleziona...",
      male: "Maschio",
      female: "Femmina",
      other_gender: "Altro",
      address_details: "Dettagli (Scala, Interno)",
      address_details_placeholder: "Es. Scala B, Int 4",
      address_placeholder: "Es. Via Roma 1",
      city_placeholder: "Milano",
      state_placeholder: "MI",
      postal_code_placeholder: "20100",
      job_section: "Lavoro e Fisco",
      tax_id: "Codice Fiscale",
      tax_id_placeholder: "RSSMRA...",
      employment_status: "Stato Occupazionale",
      employment_status_placeholder: "Dipendente, Freelance...",
      job_title: "Professione",
      job_title_placeholder: "Software Engineer..."
    },
    telegram: {
      title: "Integrazione Bot Telegram",
      desc: "Per usare il bot, inviagli il comando {cmd} per scoprire il tuo ID, poi inseriscilo qui sotto.",
      placeholder: "Es. 123456789"
    },
    password_section: {
      title: "Password di Accesso",
      desc: "Aggiorna regolarmente la tua password per mantenere l'account sicuro.",
      btn: "Modifica Password",
      modal_title: "Modifica Password",
      cancel: "Annulla",
      confirm: "Conferma",
      saving: "Salvataggio..."
    },
    biometric: {
      title: "Accesso Biometrico",
      desc: "Accedi rapidamente utilizzando Face ID, Touch ID o Windows Hello."
    },
    two_fa: {
      title: "Autenticazione a due fattori (2FA)",
      status_active: "ATTIVA",
      desc: "Proteggi il tuo account con un codice monouso generato da un'app authenticator.",
      disable_btn: "Disattiva 2FA",
      enable_btn: "Configura 2FA",
      modal_title: "Configura 2FA",
      modal_desc: "Scansiona questo codice con la tua app di autenticazione (Google Authenticator, Authy, Raivo, ecc.)",
      manual_entry: "Oppure inserisci manualmente il codice segreto:",
      verify_label: "Inserisci il codice per verificare",
      verify_btn: "Attiva Ora",
      verifying: "Verifica in corso...",
      prompt_disable: "Inserisci il codice 2FA per confermare la disattivazione:"
    },
    briefings: {
      morning_label: "Morning Briefing",
      morning_desc: "Riassunto delle spese di ieri e delle scadenze imminenti.",
      weekly_label: "Weekly Wrap-Up",
      weekly_desc: "Analisi dell'andamento dei budget ogni settimana.",
      monthly_label: "Executive Summary",
      monthly_desc: "L'estratto conto patrimoniale mensile profondo."
    },
    toasts: {
      qr_err: "Errore nella generazione del QR Code",
      conn_err: "Errore di connessione",
      two_fa_enabled: "Autenticazione a 2 fattori attivata!",
      invalid_code: "Codice non valido",
      two_fa_disabled: "2FA disattivata.",
      disable_failed: "Codice non valido. Disattivazione fallita.",
      profile_saved: "Profilo aggiornato!",
      save_err: "Errore durante il salvataggio",
      pref_saved: "Preferenza salvata!",
      pref_save_err: "Impossibile salvare la preferenza.",
      export_success: "Dati esportati con successo!",
      export_failed: "Errore durante l'esportazione dei dati.",
      passkey_todo: "Funzione Passkey da ripristinare qui",
      password_mismatch: "Le nuove password non combaciano!",
      password_changed: "Password modificata con successo!",
      password_change_err: "Errore durante il cambio password",
      loading: "Caricamento configurazioni..."
    }
  },
  dashboard: {
    title: "Dashboard Finanziaria",
    subtitle: "Pannello di controllo del patrimonio",
    overview_tab: "Sintesi",
    wealth_tab: "Patrimonio & FIRE",
    behavior_tab: "Abitudini",
    history_tab: "Storico & Record",
    forecast_tab: "Proiezioni",
    merchants_tab: "Aziende",
    budget_tab: "Budget",
    seasonality_tab: "Stagionalità",
    gamification_tab: "RPG Finanziario",
    investments_tab: "Investimenti",
    insights_tab: "Insights Avanzati",
    range_label: "Periodo:",
    insights: {
      title: "Insights & Analisi Finanziaria Avanzata",
      subtitle: "Analisi di dettaglio del comportamento e della struttura di spesa.",
      treemap_title: "Visualizzazione Treemap delle Spese ed Entrate",
      treemap_categories_exp: "Categorie di Spesa",
      treemap_categories_inc: "Categorie di Entrata",
      treemap_merchants_exp: "Merchant di Spesa",
      treemap_merchants_inc: "Merchant di Entrata",
      treemap_value: "Valore",
      essential_ratio: "Struttura di Costo: Spese Fisse vs Voluttuarie",
      essential_label: "Spese Fisse & Essenziali",
      discretionary_label: "Spese Voluttuarie & Svago",
      volatility_title: "Volatilità delle Uscite Mensili",
      volatility_desc: "Deviazione standard dei flussi in uscita. Valori bassi indicano stabilità e prevedibilità.",
      savings_trend: "Trend del Tasso di Risparmio",
      trend_improving: "IN CRESCITA 📈",
      trend_degradating: "IN CALO 📉",
      trend_stable: "STABILE ➡️",
      emergency_fund_title: "Fondo di Emergenza & Copertura Spese",
      fund_secure: "SICURO (Copre > 6 mesi)",
      fund_adequate: "ADEGUATO (Copre 3-6 mesi)",
      fund_critical: "CRITICO (< 3 mesi)",
      runway_months: "{months} mesi di autonomia",
      milestones_title: "Proiezione Pietre Miliari Patrimoniali",
      milestones_desc: "Stima del tempo necessario per raggiungere i target finanziari basato sul risparmio medio mensile di questo periodo ({savings}/mese).",
      milestone_target: "Traguardo",
      milestone_time: "Tempo Stimato",
      milestone_status: "Stato",
      status_completed: "Raggiunto ✅",
      status_planning: "Pianificato ⏳",
      never_reachable: "Non raggiungibile (risparmio negativo)"
    },
    view_as: "Vedi come:",
    burn_rate: "Burn Rate Giorno",
    avg_ticket: "Scontrino Medio",
    micro_tx: "Sindrome Caffè (<15€)",
    no_spend_days: "Giorni No-Spend",
    runway: "Runway (Sopravvivenza)",
    years_to_fire: "Anni al F.I.R.E.",
    fire_target: "Target Indipendenza",
    net_worth: "Patrimonio",
    liquid: "Libera",
    invested: "Investiti",
    locked_goals: "In Obiettivi",
    velocity: "Wealth Velocity",
    savings_rate: "Savings Rate",
    distribution: "Distribuzione Conti",
    in_bank: "In Banca",

    // Overview
    unconfirmed_alert: "Hai {count} transazioni in attesa di conferma!",
    unconfirmed_sub: "Potrebbero essere abbonamenti o inserimenti da Telegram.",
    go_to_tx: "Vai a Transazioni",
    net_worth_in_bank: "In Banca (Reali):",
    net_worth_in_goals: "Nei Salvadanai:",
    net_worth_credits: "Crediti da esigere:",
    net_worth_debts: "Debiti da pagare:",
    current_month_balance_title: "Bilancio Mese Corrente",
    pacing_title: "Pacing Spese Mese",
    pacing_time: "Tempo ({days}gg)",
    pacing_spent: "Budget speso",
    eom_forecast_title: "Previsione Fine Mese",
    eom_forecast_sub: "Stima basata sul Burn Rate ({rate}/gg)",
    financial_pressure_title: "Scadenziario & Pressione Finanziaria",
    pressure_upcoming_7d: "Imminenti (7gg)",
    pressure_remaining_month: "Residuo Mese",
    pressure_next_month: "Mese Prossimo",
    pressure_fixed_costs: "Costi Fissi/Mese",
    outflows_plural: "{count} uscite",
    planned_plural: "{count} pianificate",
    pressure_base_msg: "Pressione di base",

    // Wealth
    wealth_breakdown: "Breakdown Patrimonio",
    in_bank_label: "In banca: {amount}",
    credits_short: "{amount} Crediti",
    debts_short: "{amount} Debiti",
    wealth_velocity_label: "Wealth Velocity: {amount} / giorno",
    savings_rate_label: "Savings Rate (Mese)",
    savings_rate_sub: "Target: 20% | Tasso Investimento: {rate}%",
    fire_projection_title: "Proiezione F.I.R.E.",
    fire_years: "{years} anni",
    fire_years_over_50: "> 50 anni",
    fire_target_label: "Target Indipendenza: {amount}",
    runway_label: "Runway (Sopravvivenza):",
    runway_value: "{years} anni",
    progression_12m: "Progressione Patrimonio (12m)",
    account_distribution: "Distribuzione Conti",
    of_which_locked: "(Di cui {amount} vincolati)",

    // Behavior
    dow_title: "Spesa per Giorno della Settimana",
    dow_avg: "Media",
    weekend_weekday: "Weekend vs Weekday",
    weekday_label: "Lun-Ven",
    weekend_label: "Sab-Dom",
    month_rhythm: "Ritmo del Mese",
    first_half_label: "Giorni 1-15",
    second_half_label: "Giorni 16-31",
    income_expense_ratio_title: "Income / Expense Ratio (All-Time)",
    ratio_desc: "Per 1€ speso, guadagni {ratio}€",
    tx_count_label: "{count} tx",

    // History
    lifetime_flow: "Flusso Vitale (Lifetime)",
    lifetime_flow_desc: "I soldi transitati dal primo giorno.",
    generated_label: "Generato",
    burned_label: "Bruciato",
    monthly_income_history: "Storico Entrate Mensili (All-Time)",
    monthly_expense_history: "Storico Spese Mensili (All-Time)",
    monthly_income_tooltip: "Entrata Totale",
    monthly_expense_tooltip: "Spesa Totale",
    top_expense_categories: "Top Categorie Spesa (All-Time)",
    top_income_categories: "Top Fonti Reddito (All-Time)",
    hall_of_fame: "Hall of Fame",
    max_single_expense: "Max Spesa Singola",
    max_single_income: "Max Entrata Singola",
    worst_day: "Giorno peggiore",
    max_no_spend_streak: "Max No-Spend Streak",
    days_suffix: "{days} gg",
    days_suffix_streak: "{days} gg 🔥",
    table: {
      year: "Anno",
      income: "Entrate",
      outflows: "Uscite",
      net_savings: "Risparmio Netto",
      pct_sav: "% Sav"
    },

    // Forecast
    time_horizon: "Orizzonte Temporale",
    years_label: "{years} Anni",
    annual_return: "Rendimento Annuo Investimenti",
    capital_invested_compound: "Capitale Investito (Interesse Composto)",
    today_label: "Oggi",
    gain_label: "gain",
    liquidity_growth: "Liquidità (Crescita Lineare)",
    avg_savings_label: "Risparmio medio: {amount}/mese",
    projected_total_label: "Patrimonio Totale Proiettato",
    vs_today_label: "vs Oggi",
    trajectory_title: "Traiettoria Patrimonio",
    invisible_tax_title: "Tassa Invisibile (Inflazione 2%)",
    inflation_desc: "I tuoi attuali {amount} di liquidità, tenuti fermi per {years} anni, perderanno potere d'acquisto per un valore equivalente a:",
    year_n: "Anno {n}",

    // Merchants
    merchants_controparte: "Controparte",
    merchants_tx: "Transazioni",
    merchants_total: "Totale ({type})",
    merchants_outflow: "Uscito",
    merchants_inflow: "Ricevuto",
    merchants_none: "Nessuna controparte trovata.",
    merchants_page: "Pagina {page} di {total}",
    merchants_prev: "Precedente",
    merchants_next: "Successiva",
    merchants_by_amount: "Per Importo",
    merchants_by_freq: "Per Frequenza",

    // Budget
    budget_delete_title: "Elimina Budget",
    budget_delete_msg: "Vuoi rimuovere il budget per {category}?",
    budget_edit_title: "Modifica Budget",
    budget_new_title: "Imposta Nuovo Budget",
    budget_cat_label: "Categoria Spesa",
    budget_select_placeholder: "Seleziona...",
    budget_limit_label: "Limite Massimo (€)",
    budget_cancel: "Annulla",
    budget_save: "Salva",
    budget_spent_on: "Spesa su Budget",
    budget_set_limit: "+ Imposta Limite",
    budget_empty: "Non hai ancora impostato nessun budget mensile. Clicca su \"Imposta Limite\" per iniziare.",
    budget_remaining: "Rimanenti: {amount}",

    // Seasonality
    seasonality_title: "Spesa Storica Media per Mese",

    // Gamification
    rpg_title: "RPG Finanziario",
    rpg_subtitle: "Il tuo HUD comportamentale. Sopravvivi al mese, batti i tuoi record, fai level up.",
    rpg_boss_title: "Spazio riservato per le Boss Fight (Debiti) o le Missioni",
    rpg_boss_sub: "Prossimamente...",

    // Investments
    investments_value: "Valore Totale",
    investments_capital: "Capitale Investito",
    investments_pnl: "P&L Totale (Non Realizzato)",
    investments_positions: "Le tue Posizioni",
    investments_tbl: {
      asset: "Asset",
      shares: "Quote",
      pmc: "PMC",
      current_price: "Prezzo Attuale",
      value: "Valore",
      pnl: "P&L"
    },

    // Charts
    sankey: {
      title: "Flusso di Cassa del Mese ({month})",
      footer: "Entrate ➔ Budget Mensile ➔ Spese / Risparmio",
      budget_mensile: "Budget Mensile",
      risparmio: "Risparmio",
      avanzo: "Avanzo",
      entrate: "Entrate",
      spese: "Spese",
      fondi_buste: "Salvadanai",
      erosione: "Erosione"
    },
    milestones: {
      title: "I Gradini della Ricchezza",
      subtitle: "Il tuo percorso attraverso le pietre miliari finanziarie nel tempo.",
      reached: "Livello Raggiunto",
      real_worth: "Net Worth Reale",
      next_target: "Prossimo Target: €{target}k"
    },
    streak: {
      title: "No-Spend Streak",
      days: "Giorni",
      broken: "Hai speso oggi. La striscia è rotta.",
      promising: "Inizio promettente. Tieni duro.",
      rhythm: "Ottimo lavoro! Stai prendendo il ritmo.",
      unstoppable: "INARRESTABILE! 🔥"
    },
    heatmap: {
      title: "Mappa Comportamentale",
      generating: "Generazione mappa in corso...",
      outflows: "Uscite",
      inflows: "Entrate",
      balance: "Bilancio",
      mon: "Lun",
      wed: "Mer",
      fri: "Ven",
      jan: "Gen",
      feb: "Feb",
      mar: "Mar",
      apr: "Apr",
      may: "Mag",
      jun: "Giu",
      jul: "Lug",
      aug: "Ago",
      sep: "Set",
      oct: "Ott",
      nov: "Nov",
      dec: "Dic"
    }
  },
  transactions: {
    title: "Transazioni",
    subtitle: "Gestisci, filtra e aggiungi i tuoi movimenti.",
    filters: "Filtri",
    new_tx: "Nuova Transazione",
    search: "Cerca...",
    start_date: "Data Inizio",
    end_date: "Data Fine",
    category: "Categoria",
    account: "Conto",
    payment_method: "Metodo Pagamento",
    type: "Tipo",
    status: "Stato",
    all: "TUTTE",
    income: "Entrata",
    expense: "Spesa",
    transfer: "Trasferimento",
    unconfirmed: "Da Confermare",
    confirm_delete: "Elimina Transazione",
    delete_msg: "Sei sicuro di voler eliminare questa transazione? L'operazione è irreversibile.",
    date: "Data",
    description: "Descrizione",
    amount: "Importo",
    notes: "Note",
    envelope: "Salvadanaio",
    is_envelope_spending: "Spesa da Salvadanaio",
    currency: "Valuta",
    splits: "Divisione Spese",
    contacts: "Contatti",

    // New keys for page & components
    new_btn: "+ Nuova",
    confirm_btn: "Conferma",
    edit_btn: "Modifica",
    delete_btn: "Elimina",
    no_tx_found: "Nessuna transazione trovata per i filtri selezionati.",
    loading_data: "Caricamento dati...",
    today: "Oggi",
    yesterday: "Ieri",
    filter_bar: {
      from_date: "Da Data",
      to_date: "A Data",
      search_placeholder: "Es. Amazon, Cena, Affitto...",
      search_label: "Ricerca Libera",
      category_placeholder: "Tutte le categorie",
      account_placeholder: "Tutti i conti",
      quick_filters_label: "Filtri Rapidi:",
      all: "Tutto",
      today: "Oggi",
      last_7: "Ultimi 7 gg",
      this_month: "Questo Mese",
      last_month: "Mese Scorso",
      only_unconfirmed: "Solo Da Confermare",
      found: "Trovate:",
      delta: "Delta:"
    },
    modal: {
      nlp_title: "✍️ Inserimento Rapido con AI (Scrivi qui la tua transazione)",
      nlp_placeholder: "es: Ieri ho speso 15.50 euro da Coop con carta per la cena",
      nlp_btn: "Elabora",
      nlp_processing: "Elaborazione...",
      nlp_success: "Transazione analizzata con successo!",
      nlp_no_data: "Nessuna transazione individuata nel testo.",
      nlp_error: "Errore durante l'analisi del testo.",
      edit_title: "✏️ Modifica",
      new_title: "✨ Nuova",
      type_expense: "Spesa",
      type_income: "Entrata",
      type_transfer: "Transfer",
      date_label: "DATA",
      currency_label: "VALUTA",
      amount_label: "IMPORTO ({currency})",
      description_label: "DESCRIZIONE",
      real_bank_charge: "ADDEBITO REALE BANCARIO ({currency})",
      bank_charge_sub: "Quanto ti ha scalato la banca sull'estratto conto.",
      exchange_rate_label: "TASSO DI CAMBIO (Incluso di Fees)",
      exchange_rate_sub: "Calcolato matematicamente dal sistema.",
      category_label: "CATEGORIA",
      new_category_link: "+ Nuova",
      merchant_label: "CONTROPARTE",
      new_merchant_link: "+ Nuova",
      payment_method_label: "METODO PAGAMENTO",
      new_payment_method_link: "+ Nuovo",
      money_movement_title: "MOVIMENTO DI DENARO",
      new_account_btn: "+ Crea Nuovo Conto",
      from_account_label: "PAGA CON",
      from_account_transfer_label: "DA CONTO",
      to_account_label: "DEPOSITA SU",
      to_account_transfer_label: "A CONTO",
      envelope_title: "✉️ FONDI E BUSTE (Opzionale)",
      envelope_label: "COLLEGA A BUSTA",
      envelope_placeholder: "Nessuna busta...",
      use_envelope_money: "Usa Soldi della Busta",
      use_envelope_money_sub: "Questa spesa non impatterà il budget mensile perché hai già ammortizzato i fondi in passato.",
      debts_mode_label: "Genera Debiti/Crediti collegati a questa transazione",
      debts_add_item: "+ Aggiungi Voce",
      debts_title: "Debiti / Crediti Collegati",
      debts_empty: "Nessun debito collegato.",
      debts_new_btn: "+ Aggiungi Nuovo",
      notes_label: "NOTE",
      tags_label: "Tag (premi Invio)",
      tags_placeholder: "Es. vacanza, regalo...",
      cancel_btn: "Annulla",
      save_btn: "Salva",
      saving_btn: "Salvataggio...",
      split_lent: "Prestato",
      split_borrowed: "Debito",
      split_to_whom: "A chi?",
      split_amount_placeholder: "Quota (€)",
      split_credito: "CREDITO",
      split_debito: "DEBITO"
    },
    confirm_delete_title: "Elimina Transazione",
    confirm_delete_msg: "Sei sicuro di voler eliminare questa transazione? L'operazione è irreversibile e i saldi verranno ricalcolati.",
    quick_add_modal: {
      category_title: "Nuova Categoria ({type})",
      merchant_title: "Nuova Controparte",
      payment_title: "Nuovo Metodo Pagamento",
      name_placeholder: "Nome...",
      cancel: "Annulla",
      save: "Salva"
    },
    new_account_modal: {
      title: "Nuovo Conto",
      name_placeholder: "Nome...",
      is_investment: "Conto di Investimento",
      create: "Crea",
      cancel: "Annulla"
    }
  },
  auth: {
    login: {
      title: "MS Ledger",
      subtitle: "Proteggi il tuo patrimonio.",
      email_username: "Email o Username",
      email_placeholder: "Inserisci la tua email",
      password: "Password",
      forgot_password: "Password dimenticata?",
      totp_code: "Codice di Sicurezza (2FA)",
      totp_placeholder: "000000",
      totp_desc: "Apri la tua app Authenticator per generare il codice.",
      remember_me: "Ricordami per 30 giorni",
      submit_2fa: "Verifica e Accedi",
      submit_password: "Accedi con Password",
      back: "Indietro",
      or: "Oppure",
      face_id: "Entra con Passkey"
    },
    register: {
      subtitle: "Crea un nuovo account per iniziare.",
      username: "Username",
      username_placeholder: "es. mario99",
      email: "Email",
      email_placeholder: "mario@email.com",
      password: "Password",
      confirm_password: "Conferma Password",
      submit: "Registrati",
      have_account: "Hai già un account?",
      login_link: "Accedi"
    },
    forgot_password: {
      title: "Reset Password",
      desc: "Inserisci la tua email per ricevere il link di reset.",
      email_placeholder: "La tua email",
      submit: "Invia Link",
      success: "Controlla la tua email! Ti abbiamo inviato le istruzioni."
    },
    reset_password: {
      title: "Nuova Password",
      new_placeholder: "Nuova Password",
      confirm_placeholder: "Conferma Password",
      submit: "Aggiorna Password"
    },
    errors: {
      email_required: "Inserisci la tua Email o Username qui sopra prima di usare il Face ID.",
      user_not_found: "Utente non trovato.",
      verification_failed: "Verifica fallita.",
      biometric_error: "Errore biometrico.",
      invalid_credentials: "Email o password errati",
      email_not_verified: "Verifica la tua email prima di procedere. Controlla la tua casella di posta per il link di verifica.",
      account_not_activated: "Stiamo valutando la tua richiesta. Riprova più tardi, verrai notificato via email quando il tuo account verrà abilitato.",
      passwords_mismatch: "Le password non coincidono.",
      password_length: "La password deve essere lunga almeno 6 caratteri.",
      register_error: "Errore durante la registrazione.",
      request_error: "Errore durante la richiesta.",
      connection_error: "Connessione fallita.",
      reset_error: "Errore nel reset.",
      network_error: "Errore di rete.",
      success_register: "Registrazione completata! Controlla la tua casella di posta per verificare la tua email prima di effettuare il login.",
      success_reset: "Password resettata! Ora puoi accedere."
    }
  },
  balance: {
    title: "Chiusure e Bilanci",
    subtitle: "Riconcilia i saldi dell'app con quelli reali della banca.",
    reconciliation_btn: "Avvia Riconciliazione",
    calculating: "Calcolo...",
    liquid_title: "Liquidità & Conti Correnti",
    investments_title: "Investimenti",
    empty_msg: "Seleziona una data e clicca su \"Avvia Riconciliazione\" per iniziare.",
    toasts: {
      load_err: "Errore durante il caricamento dei saldi.",
      diff_err: "Il saldo dei conti liquidi deve corrispondere esattamente al saldo teorico (Delta = 0).",
      success_close: "Conto riconciliato con successo!",
      close_err: "Errore: {detail}"
    },
    table: {
      account: "Conto",
      expected_balance: "Saldo Teorico App",
      actual_balance: "Saldo Reale Banca",
      delta: "Delta",
      action: "Azione",
      close_btn: "Chiudi Conto",
      closed_status: "Riconciliato",
      never_closed: "Mai chiuso",
      last_closure: "Ultima: {date} ({amount})",
      copy_expected: "Copia",
      copy_expected_mobile: "Copia Teorico",
      expected_label_mobile: "Saldo Teorico",
      actual_label_mobile: "Saldo Reale in Banca",
      close_btn_mobile: "Chiudi"
    }
  },
  calendar_page: {
    title: "Calendario",
    subtitle: "Visione giornaliera con previsione degli abbonamenti futuri",
    today: "Oggi",
    loading_events: "Caricamento eventi...",
    toasts: {
      load_err: "Errore caricamento dati"
    },
    grid: {
      days: ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"],
      days_short: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"]
    }
  },
  data_page: {
    title: "Anagrafiche",
    subtitle: "Configura categorie, conti, esercenti e carte.",
    search_placeholder: "Cerca elemento...",
    new_btn: "Nuovo",
    tabs: {
      categories: "Categorie",
      accounts: "Conti Bancari",
      merchants: "Esercenti",
      payment_methods: "Metodi di Pagamento",
      contacts: "Contatti"
    },
    table: {
      name: "Nome Elemento",
      type: "Tipologia",
      account_type: "Tipo Conto",
      actions: "Azioni",
      no_categories: "Nessuna categoria trovata.",
      no_accounts: "Nessun conto trovato.",
      no_merchants: "Nessuna controparte trovata.",
      no_payments: "Nessun metodo di pagamento trovato.",
      no_contacts: "Nessun contatto trovato.",
      subcat_tooltip: "Aggiungi Sottocategoria",
      investment_badge: "Investimento",
      liquidity_badge: "Liquidità"
    },
    modal: {
      delete_title: "Elimina Elemento",
      delete_message: "Sei sicuro di voler eliminare questo elemento?",
      new_title: "Crea Nuovo Elemento",
      edit_title: "Modifica Elemento",
      name_label: "Nome",
      transaction_type: "Tipologia Transazione",
      type_expense: "Uscita (Expense)",
      type_income: "Entrata (Income)",
      type_transfer: "Giroconto (Transfer)",
      parent_label: "Sottocategoria di (Opzionale)",
      parent_none: "-- Nessuna (Categoria Principale) --",
      is_investment: "Conto di Investimento",
      is_investment_sub: "Esclude questo conto dalla liquidità rapida.",
      cancel: "Annulla",
      save: "Salva",
      first_name: "Nome",
      last_name: "Cognome",
      email: "Email",
      phone_number: "Telefono",
      vat_number: "Partita IVA",
      tax_code: "Codice Fiscale",
      address: "Indirizzo",
      website: "Sito Web",
      matching_keywords: "Parole Chiave per Matching (separate da virgola)",
      is_credit_card: "Carta di Credito",
      is_credit_card_sub: "Identifica come carta di credito.",
      is_shared: "Conto Condiviso",
      is_shared_sub: "Conto cointestato.",
      is_obsolete: "Segna come Obsoleto / Inattivo",
      is_obsolete_sub: "Nascondi dalle viste principali.",
      show_obsolete: "Mostra obsoleti",
      color: "Colore",
      icon: "Icona",
      currency: "Valuta"
    },
    toasts: {
      deleted: "Elemento eliminato.",
      delete_err: "Impossibile eliminare: {detail}",
      created: "Elemento creato!",
      updated: "Elemento aggiornato!",
      save_err: "Errore salvataggio: {detail}",
      loading: "Caricamento anagrafiche..."
    }
  },
  debts_page: {
    title: "Debiti & Crediti",
    subtitle: "Gestisci i prestiti agli amici e i tuoi debiti in sospeso.",
    new_friend: "Nuovo Amico",
    new_debt: "Nuovo Debito",
    active_tab: "Da Saldare",
    settled_tab: "Saldati",
    empty_msg: "Nessun elemento in questa sezione.",
    toasts: {
      load_err: "Errore caricamento dati",
      deleted: "Debito eliminato!",
      delete_err: "Impossibile eliminare",
      contact_created: "Contatto creato",
      debt_created: "Debito registrato",
      debt_updated: "Debito aggiornato",
      save_err: "Errore salvataggio",
      status_updated: "Stato aggiornato!",
      status_err: "Errore aggiornamento",
      repay_linked: "Transazione abbinata!",
      repay_err: "Errore",
      link_removed: "Abbinamento rimosso!"
    },
    modal: {
      delete_title: "Elimina Debito",
      delete_message: "Sei sicuro di voler eliminare questo debito? Questa azione non cancellerà i soldi in banca, ma rimuoverà il promemoria.",
      friend_title: "Nuovo Amico",
      friend_name: "Nome Amico",
      friend_placeholder: "Es. Mario Rossi",
      cancel: "Annulla",
      save: "Salva",
      debt_title: "Debito",
      debt_amount: "Importo Totale",
      debt_desc: "Descrizione (Opzionale)",
      debt_desc_placeholder: "Es. Cena pizza, prestito...",
      repay_title: "Gestisci Riconciliazione",
      repay_remaining: "Residuo da saldare: {amount}",
      repay_status: "Stato: {status}",
      repay_settled: "Saldato",
      repay_active: "Attivo",
      repay_history: "Storico Transazioni Collegate",
      repay_amount_applied: "Quota applicata",
      repay_no_links: "Nessuna transazione abbinata.",
      repay_link_new: "Abbina Nuova Transazione",
      repay_select_tx: "Seleziona una transazione...",
      repay_amount_to_apply: "Importo da Imputare a questo Debito",
      repay_settle_checkbox: "Segna come saldato (Chiudi)",
      repay_submit: "Registra Riconciliazione",
      toggle_repay_status: "Segna come {status}",
      type_lent: "Ho prestato (Credito)",
      type_borrowed: "Ho ricevuto (Debito)",
      reopen_debt: "Riapri Debito",
      close_debt: "Chiudi Debito",
      repay_total: "Rimborso",
      remaining_label: "Residuo",
      tx_removed: "Transazione Rimossa",
      search_tx: "Cerca Transazione",
      settled_info: "Questo debito è attualmente saldato. Usa il tasto 'Riapri Debito' per aggiungere nuove transazioni o clicca sul cestino dello storico per rimuovere un abbinamento sbagliato."
    },
    aggregations: {
      credits_title: "Crediti da Esigere",
      debts_title: "Debiti da Pagare",
      net_balance: "Saldi netti",
      net_credits: "Sei in attivo di {amount}",
      net_debts: "Sei in debito di {amount}",
      net_balanced: "Saldi in pareggio",
      by_friend: "Posizione per Amico",
      friend_credit: "Ti deve {amount}",
      friend_debt: "Gli devi {amount}",
      friend_settled: "In pari"
    },
    card: {
      lent: "Prestato a",
      borrowed: "Preso in prestito da",
      remaining: "Residuo: {amount} di {total}",
      settle_now: "Abbina / Salda",
      settled: "Saldato",
      no_desc: "Nessuna descrizione"
    }
  },
  documents_page: {
    inbox_title: "Inbox Telegram",
    empty_inbox: "Inbox vuota. Manda un file al bot!",
    preview_title: "Anteprima Documento",
    fullscreen_btn: "Apri a pieno schermo",
    decrypting: "Decrittazione file in corso...",
    link_section_title: "Collega a Transazione",
    search_placeholder: "Cerca per descrizione o importo...",
    link_btn: "Collega qui",
    delete_btn: "Elimina questo file",
    delete_confirm: "Eliminare il file definitivamente?",
    empty_selection: "Seleziona un documento per iniziare",
    other_features_soon: "Altre Funzioni (Coming Soon)",
    create_asset: "Crea Asset / Cespite",
    send_to_accountant: "Invia al Commercialista",
    archive_title: "Archivio Collegati",
    tab_inbox: "Inbox",
    tab_archive: "Archivio",
    empty_archive: "Nessun documento collegato trovato.",
    linked_to: "Collegato alla transazione:",
    unlink_btn: "Dissocia Transazione",
    select_transaction_title: "Seleziona Transazione",
    alias_label: "Alias / Nome personalizzato",
    alias_placeholder: "Fattura Amazon, bolletta...",
    save_alias_btn: "Rinomina",
    toasts: {
      preview_err: "Impossibile caricare l'anteprima del documento.",
      linked: "Documento collegato!",
      unlinked: "Documento scollegato!",
      alias_updated: "Alias aggiornato!"
    }
  },
  envelopes_page: {
    title: "Fondi & Buste",
    subtitle: "Accantona denaro per spese future e obiettivi ricorrenti.",
    new_btn: "Nuova Busta",
    liquid_title: "Liquidità disponibile nei conti reali",
    liquid_desc: "Quello che vedi sull'app della banca",
    allocated_title: "Allocati nelle Buste",
    allocated_desc: "Soldi già 'spesi' mentalmente",
    unallocated_title: "Ancora Liberi (Non Allocati)",
    unallocated_desc: "Il tuo VERO patrimonio spendibile",
    my_goals: "Le Tue Buste",
    empty_msg: "Nessuna busta configurata. Creane una per iniziare ad ammortizzare le spese!",
    toasts: {
      load_err: "Errore caricamento dati",
      deleted: "Busta eliminata!",
      delete_err: "Impossibile eliminare",
      saved: "Busta salvata!",
      save_err: "Errore durante il salvataggio"
    },
    card: {
      target: "Target: {target}",
      target_reached: "Completata!",
      delete_confirm: "Sei sicuro di voler eliminare questa busta?",
      no_desc: "Nessuna descrizione",
      remaining_to_target: "Mancano: {amount}"
    },
    modal: {
      new_title: "Nuova Busta",
      edit_title: "Modifica Busta",
      delete_title: "Elimina Busta",
      name: "Nome Busta",
      name_placeholder: "Es. Assicurazione Auto, Tasse...",
      allocated: "Importo Allocato (€)",
      target: "Importo Target (Opzionale, €)",
      description: "Note / Descrizione",
      description_placeholder: "Es. Scadenza Novembre, accantonamento mensile...",
      cancel: "Annulla",
      save: "Salva"
    }
  },
  goals_page: {
    title: "Obiettivi Finanziari",
    subtitle: "Pianifica i tuoi traguardi di risparmio a lungo termine.",
    new_btn: "Nuovo Obiettivo",
    allocated_title: "Allocati nei Salvadanai",
    empty_msg: "Nessun obiettivo impostato. Clicca su 'Nuovo Obiettivo' per iniziare a risparmiare!",
    toasts: {
      load_err: "Errore caricamento dati",
      deleted: "Obiettivo eliminato!",
      delete_err: "Impossibile eliminare",
      saved: "Obiettivo salvato!",
      save_err: "Errore durante il salvataggio",
      select_account: "Seleziona un conto!",
      alloc_success: "Fondi allocati con successo!",
      alloc_err: "Errore allocazione: {detail}"
    },
    card: {
      target: "Obiettivo: {amount} entro il {date}",
      allocated: "Allocato: {amount} ({pct}%)",
      delete_confirm: "Vuoi eliminare questo obiettivo? I soldi messi da parte torneranno disponibili sul saldo libero dei tuoi conti.",
      target_date: "Scadenza: {date}",
      add_funds: "Aggiungi Fondi"
    },
    modal: {
      new_title: "Nuovo Obiettivo",
      edit_title: "Modifica Obiettivo",
      delete_title: "Elimina Obiettivo",
      name: "Nome Obiettivo",
      name_placeholder: "Es. Comprare Casa, Viaggio in Giappone...",
      target: "Importo Target (€)",
      deadline: "Data Limite",
      notes: "Note / Descrizione",
      notes_placeholder: "Dettagli sull'obiettivo...",
      cancel: "Annulla",
      save: "Salva",
      allocate_title_prefix: "Sposta Fondi in",
      allocate_from_account: "DA QUALE CONTO PRELEVARE?",
      allocate_select_account: "Scegli conto...",
      allocate_desc: "I soldi resteranno nel tuo Net Worth, ma saranno nascosti dalla liquidità libera.",
      allocate_amount: "IMPORTO (€)",
      allocate_date: "DATA",
      allocate_submit: "Versa",
      optional: "Opz"
    }
  },
  investments_page: {
    title: "Investimenti & Portafoglio",
    subtitle: "Monitora i tuoi asset, calcola il PMC e registra le transazioni d'acquisto/vendita.",
    import_btn: "Importa CSV",
    new_asset_btn: "Nuovo Asset",
    new_order_btn: "Registra Ordine",
    chart_title: "Andamento Storico Portafoglio",
    empty_chart: "Nessun dato storico per il grafico.",
    positions_title: "Asset in Portafoglio",
    value: "Valore",
    commission: "Commissioni",
    order_type: "Tipo Ordine",
    date: "Data",
    shares: "Quote",
    price: "Prezzo",
    orders_history: "Storico Ordini",
    loading_msg: "Inizializzazione Terminale...",
    updating_data: "Aggiornamento dati...",
    broker_selector_all: "Tutti i Broker",
    ledger_empty: "Il ledger è vuoto. Registra la tua prima operazione.",
    positions_empty: "Nessuna posizione aperta nel portafoglio.",
    assets_empty: "Nessun asset in anagrafica.",
    tab_positions: "Posizioni Attive",
    tab_ledger: "Cronologia Ordini (Ledger)",
    tab_assets: "Anagrafica Assets",
    broker_liquidity: "Liquidità Broker",
    table: {
      asset: "Asset",
      shares: "Quote",
      pmc: "PMC",
      current_price: "Prezzo Att.",
      total_value: "Valore Totale",
      unrealized_pnl: "P&L Non Realizzato",
      date: "Data",
      event: "Evento",
      price: "Prezzo",
      value_eur: "Controvalore (EUR)",
      actions: "Azioni",
      ticker: "Ticker",
      name: "Nome",
      type: "Tipo",
      currency: "Valuta",
      last_price: "Ultimo Prezzo"
    },
    toasts: {
      load_err: "Errore durante il caricamento dei dati.",
      asset_deleted: "Asset eliminato!",
      asset_delete_err: "Impossibile eliminare l'asset.",
      order_deleted: "Ordine eliminato!",
      order_delete_err: "Impossibile eliminare l'ordine.",
      asset_saved: "Asset salvato con successo!",
      asset_save_err: "Errore durante il salvataggio dell'asset.",
      order_saved: "Ordine registrato con successo!",
      order_save_err: "Errore durante il salvataggio dell'ordine.",
      import_success: "Importazione completata con successo!",
      import_err: "Errore durante l'importazione."
    },
    modal: {
      asset_new_title: "Nuovo Asset",
      asset_edit_title: "Modifica Asset",
      ticker: "Ticker / Identificativo",
      ticker_placeholder: "Es. SWDA.MI, AAPL, BTC...",
      name: "Nome Asset",
      name_placeholder: "Es. iShares MSCI World, Apple...",
      isin: "Codice ISIN (Opzionale)",
      isin_placeholder: "Es. IE00B4L5Y983...",
      asset_class: "Asset Class",
      asset_class_placeholder: "Es. Equity, Crypto, Gold...",
      currency: "Valuta Quotazione",
      currency_placeholder: "EUR, USD, ecc.",
      current_price: "Prezzo di Mercato Attuale",
      search_ticker: "Cerca Ticker (Yahoo Finance)",
      ticker_not_found: "Ticker non trovato su Yahoo Finance.",
      ticker_verified: "Ticker Verificato",
      symbol: "Simbolo",
      instrument_name: "Nome Strumento",
      original_currency: "Valuta Originale",
      save_asset_btn: "Salva Asset in Anagrafica",
      order_new_title: "Registra Nuovo Ordine",
      order_edit_title: "Modifica Ordine",
      select_asset: "Seleziona Asset...",
      select_account: "Conto Addebito/Accredito...",
      order_type_buy: "Acquisto (BUY)",
      order_type_sell: "Vendita (SELL)",
      order_date: "Data Ordine",
      order_shares: "Quantità (Quote)",
      order_price: "Prezzo Unitario (€)",
      order_commission: "Commissioni (€, Opzionale)",
      broker_account: "Conto (Broker)",
      event_type: "Tipo Evento",
      buy_option: "BUY (Acquisto)",
      sell_option: "SELL (Vendita)",
      deposit_option: "DEPOSIT (Versamento Liquidità)",
      withdraw_option: "WITHDRAW (Prelievo Liquidità)",
      dividend_option: "DIVIDEND (Dividendo)",
      interest_option: "INTEREST (Interessi su Liquidità)",
      fee_option: "FEE (Commissione)",
      unit_price: "Prezzo (Unità)",
      total_value_eur: "Controvalore (€)",
      execution_date: "Data Esecuzione",
      confirm_order_btn: "Conferma Ordine",
      registering: "Registrazione...",
      order_notes: "Note / Dettagli transazione",
      cancel: "Annulla",
      save: "Salva",
      delete_confirm_asset: "Sei sicuro di voler eliminare questo asset? Verranno eliminati anche tutti gli ordini associati.",
      delete_confirm_order: "Sei sicuro di voler eliminare questo ordine? Il PMC e le quantità verranno ricalcolati.",
      delete_order_title: "Elimina Ordine",
      delete_order_msg: "Sei sicuro di voler eliminare questo ordine dal Ledger? L'operazione è irreversibile e ricalcolerà immediatamente posizioni e grafici."
    },
    import_page: {
      back_btn: "Torna al Terminale",
      title: "Importazione Dati Broker",
      subtitle: "Gestisci il flusso di importazione massiva dei tuoi investimenti.",
      system_aligned: "Sistema Allineato",
      ready_data: "Pronto per nuovi dati",
      step_staging: "Step 1: Staging",
      select_broker: "Seleziona Broker",
      file_label_csv: "File CSV (Trade Republic)",
      upload_data_btn: "Carica Nuovi Dati",
      step_processing: "Step 2: Elaborazione",
      processing_desc: "Analizza la staging area e crea gli eventi reali nel Ledger: acquisti, vendite, dividendi e fee verranno calcolati al centesimo.",
      staging_status: "Status Staging",
      ready_to_process: "Pronto per processare",
      process_ledger_btn: "Elabora Ledger",
      step_sync: "Step 3: Sincronizzazione",
      sync_desc: "Sincronizza i prezzi storici da Yahoo Finance. Verranno scaricati solo i dati mancanti per ottimizzare le prestazioni.",
      asset_prices: "Prezzi Asset",
      diff_update: "Aggiornamento differenziale",
      smart_backfill_btn: "Smart Backfill",
      footer_info: "ID Transazione rilevato tramite transaction_id univoco del broker.",
      safe_processing: "Elaborazione Sicura",
      dup_check: "Check Duplicati Attivo",
      loading_config: "Caricamento configurazione...",
      toasts: {
        load_acc_err: "Impossibile caricare i conti.",
        select_file_acc: "Seleziona un file e un conto di destinazione.",
        uploading_file: "Caricamento file nella staging area...",
        upload_err: "Errore durante l'upload",
        upload_conn_err: "Errore di connessione durante l'upload.",
        processing_ledger: "Elaborazione transazioni e aggiornamento Ledger...",
        process_err: "Errore durante l'elaborazione del Ledger.",
        process_conn_err: "Errore di connessione durante l'elaborazione.",
        syncing_prices: "Sincronizzazione prezzi storici da Yahoo Finance...",
        backfill_err: "Errore durante il backfill dei prezzi.",
        backfill_conn_err: "Errore di connessione durante il backfill."
      }
    }
  },
  recurring_page: {
    title: "Abbonamenti & Spese Ricorrenti",
    subtitle: "Visualizza e gestisci le uscite pianificate e i tuoi abbonamenti ricorrenti.",
    new_btn: "Nuovo Abbonamento",
    active_tab: "Attivi",
    inactive_tab: "Disattivati",
    forecast_title: "Proiezione Uscite Future",
    forecast_loading: "Calcolo proiezioni...",
    forecast_30d: "Spesa nei prossimi 30 giorni",
    forecast_90d: "Spesa nei prossimi 90 giorni",
    forecast_365d: "Spesa nei prossimi 365 giorni",
    empty_msg: "Nessun abbonamento configurato. Aggiungi il tuo primo abbonamento!",
    delete_title: "Elimina Abbonamento",
    stats_7d: "Prossimi 7 Gg",
    stats_eom: "Entro Fine Mese",
    stats_30d: "Prossimi 30 Gg",
    stats_next_month: "Mese Prossimo",
    stats_12m: "Prossimi 12 Mesi",
    stats_monthly_avg: "Media Mensile",
    toasts: {
      load_err: "Errore caricamento dati",
      deleted: "Abbonamento eliminato!",
      delete_err: "Impossibile eliminare",
      saved: "Abbonamento salvato!",
      save_err: "Errore salvataggio"
    },
    card: {
      frequency_label: "Frequenza:",
      next_date_label: "Prossimo addebito:",
      account_label: "Conto:",
      status_label: "Stato:",
      active: "Attivo",
      inactive: "Disattivato",
      freq_daily: "Giornaliero",
      freq_weekly: "Settimanale",
      freq_monthly: "Mensile",
      freq_yearly: "Annuale",
      delete_confirm: "Sei sicuro di voler eliminare questo abbonamento ricorrente?",
      suspend: "Sospendi",
      resume: "Riattiva"
    },
    modal: {
      new_title: "Nuovo Abbonamento",
      edit_title: "Modifica Abbonamento",
      description: "Descrizione / Nome",
      description_placeholder: "Es. Netflix, Spotify, Affitto...",
      amount: "Importo (€)",
      category: "Categoria",
      account: "Conto Addebito",
      frequency: "Frequenza",
      next_date: "Data Prossima Scadenza",
      is_active: "Abbonamento Attivo (Attiva scadenze future)",
      cancel: "Annulla",
      save: "Salva",
      none_placeholder: "Nessuno..."
    }
  },
  wishlist: {
    delete_btn: "Elimina",
    title: "Desideri (Wishlist con Timer)",
    subtitle: "Inserisci gli acquisti non essenziali per lasciarli 'raffreddare' ed evitare acquisti d'impulso.",
    add_btn: "Aggiungi Desiderio",
    new_wish: "Nuovo Desiderio",
    name: "Nome Oggetto",
    name_placeholder: "Es. Smartwatch, Scarpe nuove...",
    amount: "Importo (€)",
    category: "Categoria",
    merchant: "Esercente / Brand",
    merchant_placeholder: "Seleziona un esercente (opzionale)...",
    product_url: "Link Prodotto",
    product_url_placeholder: "Es. https://amazon.it/... (opzionale)",
    timer: "Periodo di Riflessione",
    timer_24: "24 Ore",
    timer_48: "48 Ore (Consigliato)",
    timer_72: "72 Ore",
    notes: "Note aggiuntive",
    notes_placeholder: "Perché voglio comprarlo? Mi serve davvero?",
    cancel: "Annulla",
    save: "Salva Desiderio",
    total_saved: "Risparmio da Autocontrollo",
    active_wishes: "Periodo di Riflessione Attivo",
    archived_wishes: "Cronologia Decisioni",
    time_left: "Tempo rimasto:",
    expired: "Tempo Scaduto!",
    want_it_question: "Vuoi ancora comprarlo?",
    yes_btn: "Sì, lo voglio ancora",
    no_btn: "No, ho cambiato idea",
    status_pending: "Riflessione",
    status_saved: "Risparmiato",
    status_bought: "Acquistato",
    empty_active: "Nessun acquisto in fase di riflessione. Ottimo autocontrollo!",
    empty_archive: "Nessuna decisione registrata in cronologia.",
    delete_confirm: "Sei sicuro di voler eliminare questo desiderio?",
    toasts: {
      load_err: "Errore nel caricamento dei desideri",
      saved: "Desiderio registrato! Il timer di raffreddamento è partito.",
      save_err: "Impossibile salvare il desiderio",
      deleted: "Desiderio rimosso",
      delete_err: "Impossibile eliminare",
      decision_saved: "Complimenti per l'autocontrollo! Spostati {amount}€ nella busta dei Risparmi.",
      decision_bought: "Desiderio confermato. Procedi pure all'acquisto!"
    }
  },
  admin_page: {
    title: "Gestione Utenti",
    subtitle: "Amministra gli utenti registrati sul sistema, abilita/disabilita l'accesso e gestisci i privilegi.",
    table: {
      username: "Username",
      email: "Email",
      status: "Stato",
      role: "Ruolo",
      registered: "Registrato il",
      email_verified: "Email Verificata",
      two_factor: "2FA",
      last_access: "Ultimo Accesso",
      last_pwd_change: "Cambio Password",
      actions: "Azioni"
    },
    status_active: "Attivo",
    status_inactive: "Disattivato",
    status_2fa_active: "Attivo",
    status_2fa_inactive: "Disattivo",
    never_changed: "Mai modificata (Reg.)",
    role_admin: "Amministratore",
    role_admin_lvl: "Amministratore (Lvl {level})",
    role_user: "Utente",
    btn_deactivate: "Disattiva",
    btn_activate: "Attiva",
    btn_make_admin: "Rendi Admin",
    btn_make_admin_placeholder: "+ Eleggi ad Admin",
    btn_remove_admin: "Rimuovi Admin",
    access_denied: "Accesso Negato",
    access_denied_msg: "Non hai i permessi necessari per accedere a questa pagina.",
    filters: {
      search_placeholder: "Cerca per username, email o nome...",
      role_all: "Tutti i ruoli",
      status_all: "Tutti gli stati",
      "2fa_all": "Tutti i 2FA"
    },
    toasts: {
      load_err: "Errore nel caricamento degli utenti",
      update_success: "Utente aggiornato con successo!",
      update_err: "Impossibile aggiornare l'utente",
      self_demotion_err: "Non puoi rimuovere i tuoi stessi permessi di amministratore."
    }
  },
  admin_market_page: {
    title: "Monitoraggio Mercati",
    subtitle: "Controlla le quotazioni degli asset (Azioni, Crypto, ETF) e i tassi di cambio Forex aggiornati via Yahoo Finance.",
    btn_refresh: "Forza Aggiornamento",
    btn_refreshing: "Aggiornamento in corso...",
    tab_tickers: "Titoli Attivi",
    tab_forex: "Tassi di Cambio",
    search_ticker_placeholder: "Cerca ticker o nome...",
    table: {
      ticker: "Ticker",
      name: "Nome",
      type: "Tipo",
      currency: "Valuta Orig.",
      price: "Ultimo Prezzo",
      user_count: "Posizioni Utente",
      last_updated: "Ultimo Aggiornamento"
    },
    forex_card: {
      from_eur: "Tasso di cambio in EUR",
      inverse: "Inverso (1 EUR = {val} {curr})"
    },
    toasts: {
      load_err: "Errore nel caricamento dei dati di mercato",
      refresh_success: "Prezzi di mercato e tassi Forex aggiornati con successo!",
      refresh_err: "Impossibile aggiornare i dati di mercato"
    }
  },
  support_page: {
    title: "Assistenza Clienti",
    subtitle: "Invia una richiesta di supporto o controlla lo stato dei tuoi ticket aperti.",
    btn_new_ticket: "+ Nuovo Ticket",
    btn_submitting: "Invio in corso...",
    btn_reply: "Invia Risposta",
    btn_replying: "Invio...",
    form: {
      title: "Apri un Nuovo Ticket",
      subject: "Oggetto",
      subject_placeholder: "Qual è il problema o la richiesta?",
      description: "Descrizione Dettagliata",
      description_placeholder: "Fornisci quante più informazioni possibili...",
      priority: "Priorità",
      btn_submit: "Invia Ticket",
      btn_cancel: "Annulla"
    },
    table: {
      id: "ID",
      subject: "Oggetto",
      status: "Stato",
      priority: "Priorità",
      created_at: "Creato il",
      last_update: "Ultima modifica",
      assigned_to: "Assegnato a"
    },
    details: {
      title: "Dettagli Ticket",
      btn_back: "Torna alla lista",
      info_title: "Informazioni Ticket",
      chat_placeholder: "Scrivi una risposta all'assistenza...",
      system_user: "Sistema",
      support_agent: "Operatore"
    },
    status: {
      open: "Aperto",
      in_progress: "In corso",
      resolved: "Risolto",
      closed: "Chiuso"
    },
    priority: {
      low: "Bassa",
      medium: "Media",
      high: "Alta",
      critical: "Critica"
    },
    toasts: {
      load_err: "Impossibile caricare i ticket.",
      create_success: "Ticket creato con successo!",
      create_err: "Errore nella creazione del ticket.",
      reply_success: "Risposta inviata con successo!",
      reply_err: "Impossibile inviare la risposta."
    }
  },
  admin_tickets_page: {
    title: "Gestione Ticket Assistenza",
    subtitle: "Risolvi i ticket degli utenti, assegnali agli admin e cambia priorità e stati.",
    table: {
      user: "Utente",
      assigned_to: "Assegnato a",
      no_assignee: "Non assegnato",
      select_assignee: "Assegna a...",
      btn_assign_me: "Prendi in carico"
    },
    filters: {
      status_all: "Tutti gli stati",
      priority_all: "Tutte le priorità",
      assigned_all: "Tutti i ticket",
      assigned_me: "Assegnati a me",
      assigned_unassigned: "Non assegnati"
    },
    toasts: {
      update_success: "Ticket aggiornato con successo!",
      update_err: "Impossibile aggiornare il ticket."
    }
  },
  admin_analytics_page: {
    title: "Statistiche Applicazione",
    subtitle: "Monitora l'attività complessiva degli utenti, i volumi dei dati inseriti, lo spazio di archiviazione e l'adozione delle misure di sicurezza.",
    cards: {
      total_users: "Utenti Registrati",
      active_users: "Utenti Attivi",
      active_desc: "7 giorni / 30 giorni",
      total_transactions: "Transazioni Totali",
      storage_size: "Spazio Documenti",
      total_tickets: "Ticket Assistenza",
      security_info: "Sicurezza Utente",
      total_ai_requests: "Richieste Google AI"
    },
    sections: {
      activity_trends: "Trend di Attività (Ultimi 7 Giorni)",
      tx_distribution: "Distribuzione Transazioni per Tipo",
      security_adoption: "Adozione Misure di Sicurezza",
      top_tx_users: "Classifica Utenti (Maggior numero di Transazioni)",
      top_storage_users: "Classifica Spazio (Maggior utilizzo di Storage)",
      attachments_mime: "Breakdown File per Tipo MIME",
      ticket_status: "Riepilogo Stato Ticket",
      top_ai_users: "Utilizzo AI per Utente"
    },
    labels: {
      active_2fa: "2FA Abilitato",
      inactive_2fa: "2FA Disabilitato",
      passkeys: "Passkey Registrate",
      open: "Aperti",
      in_progress: "In corso",
      resolved: "Risolti",
      closed: "Chiusi",
      tx_count: "{val} transazioni",
      storage_mb: "{val} MB",
      mime_type: "MIME Type",
      count: "Quantità",
      no_data: "Nessun dato disponibile.",
      ai_count: "{val} richieste"
    },
    toasts: {
      load_err: "Impossibile caricare le statistiche dell'applicazione."
    }
  },
  admin_settings_page: {
    title: "Impostazioni di Sistema",
    subtitle: "Configura i parametri globali dell'applicazione e gestisci i controlli di abilitazione delle funzionalità.",
    table: {
      key: "Impostazione",
      description: "Descrizione",
      value: "Valore",
      admin_level: "Livello Min. Modifica",
      actions: "Azioni",
      btn_save: "Salva",
      placeholder: "Valore..."
    },
    toasts: {
      load_err: "Impossibile caricare le impostazioni di sistema.",
      update_success: "Impostazione aggiornata con successo!",
      update_err: "Impossibile aggiornare l'impostazione."
    }
  }
};
